import script from "./Cadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./Cadastro.vue?vue&type=script&setup=true&lang=js"

import "./Cadastro.vue?vue&type=style&index=0&id=348f0a8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348f0a8e"]])

export default __exports__